import React, { Component, Fragment } from 'react';
import { observer, inject } from 'mobx-react';
import { withRouter } from "react-router";
import CompanyManageView from './CompanyManageView';

@inject('commonStore','companyStore')
@observer
class CompanyManageContainer extends Component {

  UNSAFE_componentWillMount() {
    this.props.companyStore.setCommonStoreInfo(this.props.commonStore);
    this.props.companyStore.onClear();

    this.props.companyStore.disCompanyList('T');
    const { sessionLoginInfo } = this.props.commonStore;
    this.props.companyStore.disCompanyList((sessionLoginInfo.cGbn !== undefined &&  sessionLoginInfo.cGbn !== null
      && sessionLoginInfo.cGbn === process.env.REACT_APP_TYPE_COMPANY_LGLOG) ? "ML" : 'M');
  }

  render() {
    const { sessionLoginInfo } = this.props.commonStore;
    return (
      <Fragment>
        <CompanyManageView 
          cGbn={(sessionLoginInfo !== null && sessionLoginInfo.cGbn !== undefined &&  sessionLoginInfo.cGbn !== null) 
            ? sessionLoginInfo.cGbn : "" }
        />
      </Fragment>
    );
  }

}

export default withRouter(CompanyManageContainer);
